import { SVGProps } from "react"
const NextArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={14}
    fill="none"
    viewBox="0 0 36 28"
    {...props}
  >
    <path
      stroke="#BAD2D4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M15.333 25.833 2 13.917m0 0L15.333 2M2 13.916h32"
    />
  </svg>
)
export default NextArrow
